define([
	'internal_util/Util',
	'internal_util/X500Util',
	'model/ActivationType',
	'model/Image',
	'model/Origin'
], function (
		Util,
		X500Util,
		ActivationType,
		Image,
		Origin
		) {
	'use strict';

	/**
	 * AuthenticationOption class
	 */
	return function (id, activation, type, protocol, issuer, description, image, attributes, requestedAttributes, derivedCredential, authnContextClassRef) {
		var _id,
				_activation,
				_type,
				_protocol,
				_issuer,
				_description,
				_image,
				_attributes,
				_requestedAttributes,
				_derivedCredential,
				_authnContextClassRef,
				_optionManager = null;

		// those attributes can be derived later from DateOfBirth in the backend
		var _ignored_requested_attrs = [ "http://www.skidentity.de/att/Age", "http://www.skidentity.de/att/AgeVerification" ];
 
		// console.groupCollapsed("New AuthenticationOption -> ",id);
		// console.info("id: ",id);
		// console.info("activation: ",activation);
		// console.info("type: ",type);
		// console.info("protocol: ",protocol);
		// console.info("issuer: ",issuer);
		// console.info("description: ",description);
		// console.groupCollapsed("derivedCredential");
		// for (var d in derivedCredential) {
		// 		console.info(derivedCredential[d].id());
		// }
		// console.groupEnd();
		// console.groupEnd();

		if (Util.isValidString(id)) {
			_id = id;
		} else {
			_id = null;
		}

		if (Util.objectHasValue(ActivationType, activation)) {
			_activation = activation;
		} else {
			throw new Error('invalid authentication option activation: ' + activation);
		}

		if (Util.isValidString(type)) {
			_type = type;
		} else {
			throw new Error('invalid authentication option type: ' + type);
		}

		if (Util.isValidString(protocol)) {
			_protocol = protocol;
		} else {
			throw new Error('invalid authentication option protocol: ' + protocol);
		}

		if (Util.isArray(issuer)) {
			_issuer = issuer;
		} else if (Util.isValidString(issuer)) {
			_issuer = new Array(issuer);
		} else {
			_issuer = new Array();
		}

		if (Util.isValidString(description)) {
			_description = description;
		} else {
			_description = null;
		}

		if (image instanceof Image) {
			_image = image;
		} else {
			_image = null;
		}

		if (Util.isArray(attributes)) {
			_attributes = attributes;
		} else {
			_attributes = new Array();
		}

		if (Util.isArray(requestedAttributes)) {
			_requestedAttributes = requestedAttributes;
		} else {
			_requestedAttributes = new Array();
		}

		if (Util.isArray(derivedCredential)) {
			_derivedCredential = derivedCredential;
		} else {
			_derivedCredential = new Array();
		}
		
		if (Util.isValidString(authnContextClassRef)) {
			_authnContextClassRef = authnContextClassRef;
		} else {
			_authnContextClassRef = "urn:oasis:names:tc:SAML:2.0:ac:classes:unspecified";
		}
		
		
		// private methods

		function matchesAttribute(attr, reqAttr) {
			// check names
			if (attr.name() !== reqAttr.name()) {
				return false;
			}
//			console.info("matchesAttribute",attr.name(),reqAttr.name());
			// check origins
			var attrOrigin = attr.origin();
			var reqAttrOrigins = reqAttr.origin();
			
			if (attrOrigin === null) {
				// attr has unknown origin, so, reqAttr matches if and only if it does not require a specific origin
				return reqAttrOrigins.length === 0;
			}
			
			if (reqAttrOrigins.length === 0) {
				// reqAttr does not require specific origin, so, any attrOrigin is ok
				return true;
			}
			
			// attr has a known origin and reqAttr requires specific origins, so, check if this origin is requested
			for (var i = 0; i < reqAttrOrigins.length; i++) {
				var reqAttrOrigin = reqAttrOrigins[i];
				//  console.groupCollapsed("Origin"+" ("+reqAttrOrigin.id()+")");
				//  console.info("Type",attrOrigin.type(),reqAttrOrigin.type());
				//  console.info("Protocol",attrOrigin.protocol(),reqAttrOrigin.protocol());
				// check that origins have same type and protocol
				if (attrOrigin.type() === reqAttrOrigin.type()
						&& attrOrigin.protocol() === reqAttrOrigin.protocol()) {
					// check that issuers match
					var reqAttrIssuers = reqAttrOrigin.issuer();
					if (reqAttrIssuers.length === 0) {
						// any attrOrigin issuers matche because reqAttrOrigin does not require specific issuers
						// console.groupEnd();
						return true;
					} else {
						// reqAttrOrigin requires specific issuers, so, check if attrOrigin provides one of them
						var attrIssuers = attrOrigin.issuer();
						for (var j = 0; j < attrIssuers.length; j++) {
							for (var k = 0; k < reqAttrIssuers.length; k++) {
								if (X500Util.compare(attrIssuers[j], reqAttrIssuers[k])) {
									// issuers match, so, origins match
									// console.groupEnd();
									return true;
								}
							}
						}
					}
				}
			//  console.groupCollapsed("Origin"+" ("+reqAttrOrigin.id()+")");
			//  console.info("Type",attrOrigin.type(),reqAttrOrigin.type());
			//  console.info("Protocol",attrOrigin.protocol(),reqAttrOrigin.protocol());
			//				  This workaround cauesed a bug: #1896, see #1898 for proper fix
			//  if(_optionManager) {
			////      console.groupCollapsed("derivedCredentials");
			//      var authOption = _optionManager.getAuthenticationOptionById(reqAttrOrigin.id());
			//				    if (authOption && !authOption.cloudID()) {
			//					console.info("CloudID: ", authOption.cloudID());
			//					var options = authOption.authenticationOptions();//.derivedCredentials();
			//					for (var opt in options) {
			//              console.info(options[opt].id());
			//					    var matches = options[opt].matchesAttributes(attr, _optionManager);
			//    //          console.groupEnd();
			//					    console.info("=====> ", matches);
			//					    if (!matches) {
			//						console.groupEnd();
			//						return matches;
			//					    }
			//					}
			//					console.groupEnd();
			//				    }
			//  }
			}
			
			return false;
		}
		
		function matchesAttributes(attributes) {
			var i,
					j,
					reqAttr,
					attr,
					found;

			if (! Util.isArray(attributes)) {
				attributes = [attributes];
			}

			for (i = 0; i < _requestedAttributes.length; i++) {
				reqAttr = _requestedAttributes[i];

				if (_ignored_requested_attrs.includes(reqAttr.name())) {
					// skip ignored requested attributes, those will be derived later by the Backend from other values
					continue;
				}
				//  console.info(reqAttr.name(),reqAttr.origin());
				if (! reqAttr.isRequired()) {
					// skip because only required requested attributes are relevant
					continue;
				}
				
				// check if reqAttr provided by attributes
				found = false;
				for (j = 0; j < attributes.length; j++) {
					attr = attributes[j];
					if (matchesAttribute(attr, reqAttr)) {
						found = true;
						// break out of inner loop over attributes and continue with next _requestedAttributes
						break;
          }
				}
				if (! found) {
					// reqAttr is required but not provided, so, return false
					return false;
				}
			}

			// all required requested attributes are provided by given attribtues, so, return true
			return true;
		}
		
		/**
		 * Check that given issuer array equals (as sets of X500 names) the issuer array of this option.
		 * 
		 * @param {Array} issuer Array of strings.
		 * @returns {Boolean}
		 */
		function matchesIssuer(issuer) {
			var i,
					j,
					found;
			
			// compare length
			if (issuer.length !== _issuer.length) {
				return false;
			}
			
			// iterate over all _issuer and check if it exists in issuer
			for (i = 0; i < _issuer.length; i++) {
				found = false;
				
				// look for _issuer[i] in issuer
				for (j = 0; j < issuer.length; j++) {
					if (X500Util.compare(_issuer[i], issuer[j])) {
						found = true;
						// break out of inner loop over issuer and continue with next _issuer
						break;
					}
				}
				
				if (! found) {
					// _issuer[i] not found in issuer list, so, sets differ
					return false;
				}
			}

			// found all _issuer in issuer, so, same sets
			return true;		
		}


		// public methods

		this.id = function () {
			return _id;
		};

		this.activation = function () {
			return _activation;
		};

		this.type = function () {
			return _type;
		};

		this.protocol = function () {
			return _protocol;
		};

		this.issuer = function () {
			return _issuer;
		};

		this.cloudID = function () {
			return (_type === "http://ws.skidentity.de/ci/v2.0");
		};

		this.description = function () {
			return _description;
		};

		this.image = function () {
			return _image;
		};

		this.attributes = function () {
			return _attributes;
		};

		this.requestedAttributes = function () {
			return _requestedAttributes;
		};
		
		this.derivedCredentials = function () {
			return _derivedCredential;
		};
		
		this.authnContextClassRef = function () {
			return _authnContextClassRef;
		};

		/**
		 * Check that the given option machtes this option.
		 * 
		 * "Matches" is defined as follows: Two options matches if and only if they have the same
		 * Type, the same Protocol, and the same Issuers. Where the Issuers are compared as set equality
		 * over X500 names.
		 * 
		 * For example {type:"npa",protocol:"eac2",issuer:["CN:Jon Doe, C=DE","CN:Max Mustermann, C=CH"]}
		 * matches {type:"npa",protocol:"eac2",issuer:["CN:Max Mustermann,C=CH","CN:Jon Doe,C=DE"]}.
		 * 
		 * @param {AuthenticationOption} authenticationOption AuthenticationOption object.
		 * @returns {Boolean} true if check succeeds; false otherwise.
		 */
		this.matchesAuthenticationOption = function (authenticationOption) {
			return _type === authenticationOption.type()
					&& _protocol === authenticationOption.protocol()
					&& matchesIssuer(authenticationOption.issuer());
		};
		
		/**
		 * Check if the given AuthenticationOption Type equals this option's Type.
		 * 
		 * @param {string} type AuthenticationOption Type.
		 * @returns {Boolean} true if given Type equals this option's Type; false otherwise.
		 */
		this.matchesType = function (type) {
			return _type === type;
		};
		
		/**
		 * Check if the given CloudIdentity is valid and usable (w.r.t. requested attributes) for this option.
		 * 
		 * @param {type} identity CloudIdentity object.
		 * @returns {Boolean} true if check succeeds; false otherwise.
		 */
		this.matchesIdentity = function (identity, optionManager) {
			if (optionManager) {
				_optionManager = optionManager;
			}
			// console.info("matchesIdentity ",_type, identity.idType());
			var matches = _type === identity.idType() 
					&& matchesAttributes(identity.attributes());
			_optionManager = null;
			return matches;
		};
 
		this.matchesAttributes = function (attr, optionManager) {
			// console.info("matchesAttributes ",_id);
			if (optionManager) {
				_optionManager = optionManager;
			}
			var matches = matchesAttributes(attr);
			_optionManager = null;
			return matches;
		};

		this.toObject = function () {
			return {
				id: _id,
				activation: _activation,
				type: _type,
				protocol: _protocol,
				issuer: _issuer,
				description: _description,
				image: Util.serialize(_image),
				attributes: Util.serialize(_attributes),
				requestedAttributes: Util.serialize(_requestedAttributes),
				derivedCredential: Util.serialize(_derivedCredential)
			};
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/AuthenticationOption.js
// module id = 25
// module chunks = 3